import React, { useEffect, useState } from 'react'
import styles from './garden.module.css'

const Garden = (props) => {

    const {roles, activities, responsibilities, currentPerson, currentArea, currentRole, currentActivity, className, handleRole, handleActivity, style} = props
    const settings = {
        roles: {FE: {x:8, y:3}, BE: {x:6, y:3}, SRE: {x:2, y:7}, QA: {x:10, y:5}, GX: {x:10, y:3}, UX: {x:12, y:5}, PO: {x:12, y:3}, PdM: {x:8, y:7}, EM: {x:6, y:7}, TL: {x:8, y:5}, PE: {x:6, y:5}, PjM: {x:6, y:9}, AM: {x:8, y:9}, CL: {x:12, y:1}, OM: {x:4, y:9}, PC: {x:4, y:7}, BDL: {x:4, y:1}, SD: {x:4, y:3}, CS: {x:2, y:5}, BC: {x:10, y:7}, BK: {x:0, y:3}, CFO: {x:2, y:3}},
        activities: {business_goals: {x:12, y:2, img: 19}, accept_stories: {x:13, y:3, img: 34}, grow_expertise: {x:5, y:6, img: 28}, good_architecture: {x:5, y:8, img: 38}, improve_processes: {x:7, y:6, img: 25}, forecast_staff: {x:7, y:9, img: 1}, software_design: {x:5, y:5, img: 40}, technical_risks: {x:7, y:5, img: 36}, plan_iteration: {x:9, y:4, img: 10}, plan_roadmap: {x:7, y:7, img: 44}, design_interactions: {x:11, y:5, img: 31}, implement_UX: {x:9, y:3, img: 21}, design_API: {x:5, y:4, img: 9}, code_functionality: {x:5, y:3, img: 41}, code_tests: {x:7, y:3, img: 42}, test_cases: {x:10, y:6, img: 13}, run_tests: {x:9, y:5, img: 32}, test_automation: {x:10, y:4, img: 45}, design_QA: {x:11, y:4, img: 11}, visual_brand: {x:12, y:4, img: 29}, communicate_product: {x:11, y:3, img: 15}, design_look: {x:10, y:2, img: 8}, social_media: {x:11, y:0, img: 35}, website: {x:13, y:1, img: 2}, internal_comms: {x:13, y:2, img: 6}, manage_expectations: {x:8, y:8, img: 43}, develop_stories: {x:8, y:6, img: 30}, prioritize_backlog: {x:9, y:7, img: 14}, user_research: {x:11, y:6, img: 33}, personas_stories: {x:13, y:4, img: 23}, user_testing: {x:13, y:6, img: 18}, manage_vendors: {x:4, y:10, img: 46}, events_trips: {x:5, y:9, img: 47}, facilities: {x:4, y:8, img: 22}, CI_CD: {x:2, y:6, img: 27}, infrastructure: {x:3, y:6, img: 24}, release_management: {x:1, y:8, img: 12}, negotiate_contract: {x:3, y:4, img: 20}, issue_invoices: {x:9, y:8, img: 39}, qualify_leads: {x:4, y:2, img: 3}, scope_budget: {x:4, y:4, img: 26}, employee_contracts: {x:3, y:5, img: 5}, agreement_templates: {x:1, y:5, img: 48}, marketing_collateral: {x:11, y:1, img: 16}, ledgers: {x:1, y:2, img: 37}, sales_target: {x:3, y:2, img: 17}, accounts_payable: {x:2, y:2, img: 4}, taxes: {x:1, y:3, img: 7}, payroll: {x:2, y:4, img: 35}, cashflow: {x:1, y:4, img: 1}, customer_fees: {x:3, y:3, img: 30}, employee_feedback: {x:4, y:6, img: 46}, recruiting: {x:3, y:7, img: 39}, track_payments: {x:11, y:8, img: 16}, customer_retention: {x:9, y:9, img: 33}, software_documentation: {x:6, y:4, img: 3}, technica_debt: {x:6, y:6, img: 18}, server_security: {x:2, y:8, img: 8}, data_backups: {x:1, y:7, img: 29}, server_monitoring: {x:1, y:6, img: 36}, track_progress: {x:6, y:8, img: 14}, review_culture: {x:3, y:8, img: 44}, share_culture: {x:5, y:7, img: 13}, requirement_gathering: {x:7, y:8, img: 17}, project_plan: {x:6, y:10, img: 12}, standups: {x:7, y:4, img: 38}, assign_tasks: {x:8, y:4, img: 15}, billable_expenses: {x:9, y:6, img: 20}, technical_debt: {x: 6, y:6, img: 40}}
    }
    const size = 180
    const connectorRadius = 12
    const top = 1
    const right = 2
    const bottom = 4
    const left = 8
    const long = 16
    const strokeWidth = 3
    const [skipCentering, setSkipCentering] = useState(false)
    let garden, scroll, selected

    const bounds = Object.entries({...settings.roles, ...settings.activities}).reduce((bounds, [key, value]) => {
        bounds.left = Math.min(bounds.left, value.x)
        bounds.top = Math.min(bounds.top, value.y)
        bounds.right = Math.max(bounds.right, value.x)
        bounds.bottom = Math.max(bounds.bottom, value.y)
        return bounds
    }, {left: Infinity, top: Infinity, right: 0, bottom: 0})

    const viewBox = [
        (bounds.left) * size - strokeWidth,
        (bounds.top) * size - strokeWidth,
        (bounds.right - bounds.left) * size + strokeWidth * 2,
        (bounds.bottom - bounds.top) * size + strokeWidth * 2
    ]

    const orthogonal = (role, activity) => {
        let d = ''
        try {
            const roleX = settings.roles[role.name].x * size
            const roleY = settings.roles[role.name].y * size
            const activityX = settings.activities[activity.name].x * size
            const activityY = settings.activities[activity.name].y * size
    
            let orientation = 0
            if(roleX < activityX) {
                orientation |= right
            } else if (roleX > activityX) {
                orientation |= left
            }
            if(roleY < activityY) {
                orientation |= bottom
            } else if (roleY > activityY) {
                orientation |= top
            }
            if(Math.abs(roleX - activityX) > size) {
                orientation |= long
            }

            d = `M${roleX},${roleY}`
            switch(orientation) {
                case top:
                    d += `h-${size / 2 - connectorRadius}${arc(3,1)}V${activityY + connectorRadius}${arc(2,1)}H${activityX}`
                    break
                case top | right:
                    d += `h${size / 2 - connectorRadius}${arc(4,0)}V${activityY + connectorRadius}${arc(2,1)}H${activityX}`
                    break
                case top | right | long:
                    d += `v-${size / 2 - connectorRadius}${arc(2,1)}H${activityX - size / 2 - connectorRadius}${arc(4,0)}V${activityY + connectorRadius}${arc(2,1)}H${activityX}`
                    break
                case right:
                    d += `H${activityX}`
                    break
                case right | long:
                    d += `v-${size / 2 - connectorRadius}${arc(2,1)}H${activityX - connectorRadius}${arc(1,1)}V${activityY}`
                    break
                case bottom | right:
                    d += `h${size / 2 - connectorRadius}${arc(1,1)}V${activityY - connectorRadius}${arc(3,0)}H${activityX}`
                    break
                case bottom | right | long:
                    d += `h${size / 2 - connectorRadius}${arc(1,1)}V${activityY - size / 2 - connectorRadius}${arc(3,0)}H${activityX - connectorRadius}${arc(1,1)}V${activityY}`
                    break
                case bottom:
                    d += `h${size / 2 - connectorRadius}${arc(1,1)}V${activityY - connectorRadius}${arc(4,1)}H${activityX}`
                    break
                case bottom | left:
                    d += `h-${size / 2 - connectorRadius}${arc(2,0)}V${activityY - connectorRadius}${arc(4,1)}H${activityX}`
                    break
                case bottom | left | long:
                    d += `h-${size / 2 - connectorRadius}${arc(2,0)}V${activityY - size / 2 - connectorRadius}${arc(4,1)}H${activityX + connectorRadius}${arc(2,0)}V${activityY}`
                    break
                case left:
                    d += `H${activityX}`
                    break
                case left | long:
                    d += `v-${size / 2 - connectorRadius}${arc(1,0)}H${activityX + connectorRadius}${arc(2,0)}V${activityY}`
                    break
                case top | left:
                    d += `h-${size / 2 - connectorRadius}${arc(3,1)}V${activityY + connectorRadius}${arc(1,0)}H${activityX}`
                    break
                case top | left | long:
                    d += `v-${size / 2 - connectorRadius}${arc(1,0)}H${activityX + size / 2 + connectorRadius}${arc(3,1)}V${activityY + connectorRadius}${arc(1,0)}H${activityX}`
                    break
                default:
                    break
            }
        } catch (e) {}

        return d || ''
    }

    const arc = (quadrant, sweep) => {
        let x, y
        switch (quadrant) {
            case 1:
                x = connectorRadius
                y = connectorRadius
                break
            case 2:
                x = connectorRadius
                y = -connectorRadius
                break
            case 3:
                x = -connectorRadius
                y = -connectorRadius
                break
            case 4:
            default:
                x = -connectorRadius
                y = connectorRadius
                break
        }
        if(!sweep) {
            x *= -1
            y *= -1
        }
        return `a${connectorRadius},${connectorRadius} 0 0 ${sweep} ${x},${y}`
    }

    const responsibilityValue = (responsibility) => {
        switch(responsibility.raci) {
            case 'RA':
                return 4;
            case 'A':
                return 3;
            case 'R':
                return 2;
            case 'C':
                return 1;
            default:
                return 0;
        }
    }

    const sortResponsibilities = (a, b) => {
        return responsibilityValue(a) - responsibilityValue(b)
    }

    const isometric = (roles, responsibilities, activities, className) => {
        
        return (
            <div className={className} ref={ref => ref = selected = className === styles.isometric? ref : selected}>
                <svg width={viewBox[2]} height={viewBox[3]} viewBox={viewBox.join(' ')} style={{left: viewBox[0], top: viewBox[1]}}>
                    {
                        responsibilities.sort(sortResponsibilities).map(responsibility => (
                            <g key={responsibility.id}>
                                <path className={styles.padding} d={orthogonal(responsibility.role, responsibility.activity)}/>
                                <path className={`${styles.connector} ${styles[responsibility.raci]}`} d={orthogonal(responsibility.role, responsibility.activity)}/>
                            </g>
                        ))
                    }
                </svg>
                <div>
                    {
                        roles.map(role => {
                            const { id, name, title } = role
                            const roleSettings = settings.roles[name]
                            if(!roleSettings) {
                                console.warn(`Role ${title} (${name}) has no place in the garden yet`)
                                return null
                            }

                            const { x, y } = roleSettings ?? {}

                            return (
                                <div ref={ref => role.ref = ref} key={id} className={styles.role} data-entity='role' data-id={`${name}`} style={{left: `${x * size}px`, top: `${y * size}px`}} role='button' tabIndex={0} onKeyDown={() => {}} onClick={() => {setSkipCentering(true); handleRole(role)}}>
                                    <div className={styles.cell}>
                                        <img src={`/images/roles/${name}.svg`} alt={name}/>
                                    </div>
                                    <div className={styles.label}>{title}</div>
                                </div>
                            )
                        })
                    }
                    {
                        activities.map(activity => {
                            const { id, name, title } = activity
                            const activitySettings = settings.activities[name]
                            if(!activitySettings) {
                                console.warn(`Activity ${title} (${name}) has no place in the garden yet`)
                                return null
                            }

                            const { x, y, img } = activitySettings ?? {}

                            return (
                                <div ref={ref => activity.ref = ref} key={id} className={styles.activity} data-entity='activity' data-id={`${name}`} style={{left: `${x * size}px`, top: `${y * size}px`}} role='button' tabIndex={0} onKeyDown={() => {}} onClick={() => {setSkipCentering(true); handleActivity(activity)}}>
                                    <div className={styles.cell}>
                                        <img src={`/images/activities/${img}.png`} alt={name}/>
                                    </div>
                                    <div className={styles.label}>{title}</div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }

    let selectedRoles, selectedResponsibilities, selectedActivities
    if(currentPerson) {
        selectedRoles = [...currentPerson.roles]
        selectedResponsibilities = selectedRoles.map(role => role.responsibilities).flat()
        selectedActivities = [...new Set(selectedResponsibilities.map(responsibility => responsibility.activity))]
    } else if(currentArea) {
        selectedRoles = roles.filter(role => role.area === currentArea)
        selectedResponsibilities = selectedRoles.map(role => role.responsibilities).flat()
        selectedActivities = [...new Set(selectedResponsibilities.map(responsibility => responsibility.activity))]
    } else if(currentRole) {
        selectedRoles = [currentRole]
        selectedResponsibilities = selectedRoles.map(role => role.responsibilities).flat()
        selectedActivities = selectedResponsibilities.map(responsibility => responsibility.activity)
    } else if(currentActivity) {
        selectedActivities = [currentActivity]
        selectedResponsibilities = selectedActivities.map(activity => activity.responsibilities).flat()
        selectedRoles = selectedResponsibilities.map(responsibility => responsibility.role)
    } else {
        selectedRoles = [...roles]
        selectedResponsibilities = [...responsibilities]
        selectedActivities = [...activities]
    }

    const dimmedRoles = roles.filter(role => !selectedRoles.includes(role))
    const dimmedResponsibilities = responsibilities.filter(responsibility => !selectedResponsibilities.includes(responsibility))
    const dimmedActivities = activities.filter(activity => !selectedActivities.includes(activity))

    useEffect(() => {
        if(skipCentering) {
            setSkipCentering(false)
        } else {
            const wrapperLeft = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--wrapper-left'))
            const wrapperTop = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--wrapper-top'))
            let selected
            if(currentPerson) {
                selected = [...currentPerson.roles]
            } else if(currentArea) {
                selected = roles.filter(role => role.area === currentArea)
            } else if(currentRole) {
                selected = [currentRole]
            } else if(currentActivity) {
                selected = [currentActivity]
            } else {
                selected = [...roles]
            }

            const selectedBounds = selected.reduce((bounds, item) => {
                if(!item.ref) return bounds
                const itemBounds = item.ref.getBoundingClientRect()
                bounds.left = Math.min(bounds.left, itemBounds.x - garden.offsetLeft + scroll.scrollLeft)
                bounds.top = Math.min(bounds.top, itemBounds.y - scroll.offsetTop + scroll.scrollTop)
                bounds.right = Math.max(bounds.right, itemBounds.x - garden.offsetLeft + scroll.scrollLeft)
                bounds.bottom = Math.max(bounds.bottom, itemBounds.y - scroll.offsetTop + scroll.scrollTop)
                return bounds
            }, {left: Infinity, top: Infinity, right: 0, bottom: 0})

            const center = {
                x: (selectedBounds.left + selectedBounds.right) / 2 - wrapperLeft ,
                y: (selectedBounds.top + selectedBounds.bottom) / 2 - wrapperTop 
            }
            scroll.scrollTo({
                left: center.x + wrapperLeft - garden.clientWidth / 2,
                top: center.y + scroll.clientHeight / 2,
                behavior: 'smooth'
            });
        }
    }, [currentPerson, currentArea, currentRole, currentActivity, garden, roles, scroll, skipCentering])

    return (
        <div ref={ref => garden = ref} className={`${className} ${styles.garden}`} style={style}>
            <div ref={ref => scroll = ref} className={styles.scroll}>
                <div className={styles.clip}>
                    <div  className={styles.wrapper}>
                        {
                            isometric(dimmedRoles, dimmedResponsibilities, dimmedActivities, `${styles.isometric} ${styles.dimmed}`)
                        }
                        {
                            isometric(selectedRoles, selectedResponsibilities, selectedActivities, styles.isometric)
                        }
                    </div>
                </div>
            </div>
            <div className={styles.shadow}/>
            <div className={styles.legends}>
                <div className={styles.legend}>
                    <svg viewBox='0 0 24 8' width='24px' height='8px'>
                        <path d='M0 4h24' className={`${styles.connector} ${styles.RA}`}/>
                    </svg>
                    <span>Responsible and Acountable</span>
                </div>
                <div className={styles.legend}>
                    <svg viewBox='0 0 24 8' width='24px' height='8px'>
                        <path d='M0 4h24' className={`${styles.connector} ${styles.A}`}/>
                    </svg>
                    <span className='tooltip' data-tooltip={'Decision maker and ultimately answerable for the correct completion of the task'}>Acountable</span>
                </div>
                <div className={styles.legend}>
                    <svg viewBox='0 0 24 8' width='24px' height='8px'>
                        <path d='M0 4h24' className={`${styles.connector} ${styles.R}`}/>
                    </svg>
                    <span className='tooltip' data-tooltip={'Works to complete the task'}>Responsible</span>
                </div>
                <div className={styles.legend}>
                    <svg viewBox='0 0 24 8' width='24px' height='8px'>
                        <path d='M0 4h24' className={`${styles.connector} ${styles.C}`}/>
                    </svg>
                    <span className='tooltip' data-tooltip={'Provides expertise and guidance'}>Consulted</span>
                </div>
                <div className={styles.legend}>
                    <svg viewBox='0 0 24 8' width='24px' height='8px'>
                        <path d='M0 4h24' className={`${styles.connector} ${styles.I}`}/>
                    </svg>
                    <span className='tooltip' data-tooltip={'Kept up-to-date on progress'}>Informed</span>
                </div>
            </div>
        </div>
    )
}

export default Garden